<div class="min-h-screen flex flex-col bg-white font-sans">
  
  <div class="flex-grow flex flex-col items-center justify-center px-4">

    <!-- STEP 1: Select User Type -->
    <ng-container *ngIf="currentStep === 1">
      <div class="text-center mb-8">
        <img src="../../../assets/icons/techsurance-logo.png" 
             class="mx-auto h-24 w-auto mb-4" alt="Techsurance Logo" />
        
        <h1 class="text-2xl font-bold text-gray-900 tracking-tight mb-1">Techsure Learn</h1>
        <p class="text-gray-600 italic text-sm sm:text-base">
          Induction training and assessments
        </p>
      </div>

      <form [formGroup]="typeForm" (ngSubmit)="onContinue()" class="w-full max-w-[500px] space-y-6">
        
        <!-- Radio Button Cards -->
        <div class="flex flex-col sm:flex-row gap-4 justify-center">
          <label class="flex-1 flex items-center px-5 py-4 rounded-lg border cursor-pointer transition-all"
                 [ngClass]="{
                   'border-[#1D4586] bg-[#E9F0E6]': typeForm.get('employeeType')?.value === 'new_joinee', 
                   'border-gray-200 bg-white hover:border-gray-300': typeForm.get('employeeType')?.value !== 'new_joinee'
                 }">
            <input type="radio" formControlName="employeeType" value="new_joinee" 
                   class="form-radio h-5 w-5 text-[#1D4586] focus:ring-[#1D4586] border-gray-300" />
            <span class="ml-3 font-semibold text-gray-800">New joinee</span>
          </label>

          <label class="flex-1 flex items-center px-5 py-4 rounded-lg border cursor-pointer transition-all"
                 [ngClass]="{
                   'border-[#1D4586] bg-[#E9F0E6]': typeForm.get('employeeType')?.value === 'existing', 
                   'border-gray-200 bg-white hover:border-gray-300': typeForm.get('employeeType')?.value !== 'existing'
                 }">
            <input type="radio" formControlName="employeeType" value="existing" 
                   class="form-radio h-5 w-5 text-[#1D4586] focus:ring-[#1D4586] border-gray-300" />
            <span class="ml-3 font-semibold text-gray-800">Existing employee</span>
          </label>
        </div>

        <button type="submit" 
                class="w-full bg-[#1D4586] text-white py-3 rounded-lg font-semibold text-lg flex justify-center items-center
                       hover:bg-[#16366b] transition-colors disabled:opacity-50 disabled:cursor-not-allowed" 
                [disabled]="typeForm.invalid || isCheckingSession">
          <svg *ngIf="isCheckingSession" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          {{ isCheckingSession ? 'Checking...' : 'Continue' }}
        </button>
      </form>
    </ng-container>

    <!-- STEP 2: Old Login Form for Existing Users -->
    <ng-container *ngIf="currentStep === 2">
      <div class="text-center mb-8">
        <img src="../../../assets/icons/techsurance-logo.png" 
             class="mx-auto h-24 w-auto mb-7" alt="Techsurance Logo" />
        
        <h1 class="text-2xl font-bold text-gray-900 tracking-tight mb-1">Techsure</h1>
        <p class="text-gray-600 italic text-sm sm:text-base">
          AI Assistant for smarter and faster underwriting
        </p>
      </div>

      <form [formGroup]="credentialsForm" (ngSubmit)="onLogin()" 
            class="w-full max-w-[320px] sm:max-w-md space-y-5">
        
        <div class="space-y-4">
          <input type="text" 
                 class="w-full px-4 py-3 rounded-lg bg-[#E9F0E6] border border-gray-200 
                        text-gray-700 placeholder:text-gray-500 focus:ring-2 focus:ring-[#1D4586] outline-none transition-all" 
                 placeholder="User ID"
                 formControlName="username" />

          <input type="password" 
                 class="w-full px-4 py-3 rounded-lg bg-[#E9F0E6] border border-gray-200 
                        text-gray-700 placeholder:text-gray-500 focus:ring-2 focus:ring-[#1D4586] outline-none transition-all" 
                 placeholder="Password" 
                 formControlName="password" />
        </div>

        <button type="submit" 
                class="w-full bg-[#1D4586] text-white py-3 rounded-lg font-semibold text-lg
                       hover:bg-[#16366b] transition-colors disabled:opacity-50 disabled:cursor-not-allowed" 
                [disabled]="credentialsForm.invalid">
          Login
        </button>

        <!-- Back link -->
        <div class="text-center mt-4">
          <button type="button" (click)="currentStep = 1" class="text-sm font-semibold text-[#1D4586] hover:underline">
            &larr; Go back
          </button>
        </div>
      </form>
    </ng-container>

  </div>

  <!-- Footer -->
  <footer class="bg-[#E9F0E6] py-3 px-6 flex items-center text-xs text-gray-800 font-medium mt-auto shrink-0">
    <div class="flex items-center">
        <span class="border-r border-gray-400 pr-2 mr-2">Powered by VIGI</span>
        <span>© {{ currentYear }} CleverNav</span>
    </div>
  </footer>

</div>

<!-- Error Popup -->
<div *ngIf="showSuccessPopup" class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
  <div class="bg-white p-6 rounded-lg shadow-xl text-center w-80">
    <p class="text-red-600 font-semibold mb-4 text-lg">
      Invalid Credentials!
    </p>
    <button (click)="showSuccessPopup = false" 
            class="bg-[#1D4586] text-white px-8 py-2 rounded-md hover:bg-[#16366b] transition-colors">
      OK
    </button>
  </div>
</div>